import {
  getEmiratesIdOtpResendSeconds,
  subscribeEmiratesIdOtpResendConfig,
} from '@/core/services/emiratesIdOtpResendConfigService';
import { useSyncExternalStore } from 'react';

/** Contentful `locales` → auth namespace → `emiratesIdOtpResendSeconds`. */
export function useEmiratesIdOtpResendSeconds(): number {
  return useSyncExternalStore(
    subscribeEmiratesIdOtpResendConfig,
    getEmiratesIdOtpResendSeconds,
    getEmiratesIdOtpResendSeconds,
  );
}
